import { createFileRoute } from '@tanstack/react-router';
import type { ReactElement } from 'react';

import { ListScreen } from '~/features/lists/list-screen';
import { listSearchSchema } from '~/features/lists/list-search-schema';

/**
 * One list (web-redesign-05 Decided 8): its entries in the shared table, and
 * an entry open beside it at `?entry=`, changed there at `&edit=true`.
 */
function ListRoute(): ReactElement {
  const { listId } = Route.useParams();
  const address = Route.useSearch();
  return <ListScreen listId={listId} address={address} />;
}

export const Route = createFileRoute('/_app/lists/$listId')({
  validateSearch: listSearchSchema,
  component: ListRoute,
});
